import {
  BOWTIE_BLUE,
  BOWTIE_PINK,
  DRAGON_FRUIT,
  GRAPHITE,
  INK,
  PEBBLE,
  STONE,
  WHITE,
} from '@bowtie-ins/bowkit/palette';
import { createTheme } from '@material-ui/core/styles';

const FONTS = [
  'Gilroy',
  'Noto Sans CJK TC',
  'Noto Sans TC',
  'Helvetica',
  'Arial',
  'sans-serif',
];

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 800,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: BOWTIE_PINK,
    },
    secondary: {
      main: BOWTIE_BLUE,
    },
    text: {
      secondary: STONE,
    },
    divider: PEBBLE,
  },
  typography: {
    fontFamily: FONTS.join(','),
    fontSize: 16,
    h6: {
      color: INK,
      fontSize: '1.125rem',
      lineHeight: 4 / 3,
      fontWeight: 700,
      letterSpacing: 0,
    },
    body2: {
      color: INK,
      fontSize: '1rem',
      lineHeight: 3 / 2,
      fontWeight: 700,
      letterSpacing: 0,
    },
    body1: {
      color: GRAPHITE,
      fontSize: '1rem',
      lineHeight: 3 / 2,
      fontWeight: 400,
      letterSpacing: 0,
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 700,
      lineHeight: 3 / 2,
      letterSpacing: 0,
    },
    caption: {
      fontSize: '0.75rem',
      color: GRAPHITE,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 8,
        minWidth: 104,
        padding: 14,
      },
      containedPrimary: {
        backgroundColor: BOWTIE_PINK,
        color: WHITE,
        boxShadow: 'unset',
        borderRadius: '50px',
        '&:hover': {
          backgroundColor: DRAGON_FRUIT,
        },
      },
      containedSecondary: {
        backgroundColor: BOWTIE_BLUE,
        color: WHITE,
        boxShadow: 'unset',
        borderRadius: '50px',
        '&:hover': {
          backgroundColor: BOWTIE_BLUE,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderColor: GRAPHITE,
        borderRadius: 5,
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiFilledInput: {
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiSelect: {
      outlined: {
        padding: '8px 24px 8px 24px',
      },
    },
    MuiMenuItem: {
      root: {
        color: INK,
      },
    },
    // https://github.com/mui-org/material-ui/issues/16866
    MuiRadio: {
      root: {
        '&&:hover': {
          backgroundColor: 'transparent',
        },
        '&$checked': {
          '&&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiSlider: {
      root: {
        '@media (pointer: coarse)': {
          padding: '20px 0px 5px 0px',
        },
      },
      thumb: {
        width: 24,
        height: 24,
        marginTop: -10,
        border: '2px solid currentColor',
      },
      track: {
        height: 4,
        borderRadius: 4,
      },
      rail: {
        height: 4,
        borderRadius: 4,
        color: '#dcdcdc',
      },
    },
  },
});

export default theme;
